import { useLocation } from 'react-router-dom';
import { parse, stringify } from 'querystring';

export function useQuery() {
  const { search } = useLocation();
  const query = parse(search.replace('?', ''));
  return {
    query,
    merge: params => merge(params, query)
  }
}

function merge(params, query) {
  const merged = {
    ...query,
    ...params,
  }
  for (let key in merged) {
    if (merged[key] === false || merged[key] === undefined) {
      delete merged[key];
    }
  }
  return '?' + stringify(merged);
}
